@if (isLoading$ | async) {
  <div class="spinner-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
